import React from 'react'
import styles from '../../settings.css'

const ReportTable = ({ columns, dataSource }) => {
  return (
    <div className={styles.table}>
      <div className={styles.tableHeader}>
        {
          columns.length > 0 && columns.map(item => (
            <span key={item.dataIndex}>{item.title}</span>
          ))
        }
      </div>
      <div className={styles.tableContent}>
        {
          dataSource instanceof Array && dataSource.length > 0 ? dataSource.map((item, index) => (
            <div key={index} className={styles.tableItem}>
              {
                columns.map(cell => (
                  <span key={cell.dataIndex}>{item[cell.key]}</span>
                ))
              }
            </div>
          )) : <div key={0} className={styles.tableItem}>
            <span>暂无数据</span>
          </div>
        }
      </div>
    </div>
  )
}

export default ReportTable
